import React from 'react';
import { motion } from 'framer-motion';
const tiers = [{
  name: 'Recon',
  price: '2,400',
  desc: 'For sites with <500 reviews.',
  features: ['Schema audit', 'Basic monetization review', 'Monthly SEO report'],
  featured: false
}, {
  name: 'Campaign',
  price: '5,800',
  desc: 'For growing review platforms.',
  features: ['Full schema architecture', 'Monetization rewiring', 'Content strategy', 'Bi-weekly analytics'],
  featured: true
}, {
  name: 'Dominion',
  price: '11,200',
  desc: 'For established comparison platforms.',
  features: ['Everything in Campaign', 'Dedicated strategist', 'Custom analytics dashboard', 'Priority support', 'Quarterly content audits'],
  featured: false
}];
export function Pricing() {
  return <section id="pricing" className="py-32 bg-gameu-base" data-id="element-89">
      <div className="max-w-7xl mx-auto px-6" data-id="element-90">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16 text-center" data-id="element-91">
          <h2 className="font-serif text-5xl md:text-6xl text-gameu-text mb-6" data-id="element-92">
            Investment Tiers
          </h2>
          <p className="text-gameu-muted text-lg max-w-2xl mx-auto" data-id="element-93">
            Transparent pricing in EUR. No hidden fees, just engineered growth.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-94">
          {tiers.map((tier, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className={`relative p-8 border flex flex-col ${tier.featured ? 'bg-gameu-elevated border-gameu-accent' : 'bg-gameu-card border-gameu-elevated'}`} data-id="element-95">
              {tier.featured && <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gameu-accent text-gameu-base text-xs font-bold uppercase tracking-wider px-4 py-1" data-id="element-96">
                  Most Chosen
                </div>}

              <h3 className="text-2xl font-serif text-gameu-text mb-2" data-id="element-97">
                {tier.name}
              </h3>
              <p className="text-gameu-muted text-sm mb-6 h-10" data-id="element-98">{tier.desc}</p>

              <div className="mb-8" data-id="element-99">
                <span className="text-4xl font-medium text-gameu-text" data-id="element-100">
                  €{tier.price}
                </span>
                <span className="text-gameu-muted" data-id="element-101">/mo</span>
              </div>

              <ul className="space-y-4 mb-8 flex-grow" data-id="element-102">
                {tier.features.map((feature, fIdx) => <li key={fIdx} className="flex items-start gap-3 text-sm text-gameu-text" data-id="element-103">
                    <svg className="w-5 h-5 text-gameu-accent shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-104">
                      <path d="M20 6L9 17l-5-5" strokeLinecap="round" strokeLinejoin="round" data-id="element-105" />
                    </svg>
                    {feature}
                  </li>)}
              </ul>

              <button className={`w-full py-3 font-medium transition-colors ${tier.featured ? 'bg-gameu-accent text-gameu-base hover:bg-white' : 'bg-gameu-elevated text-gameu-text hover:bg-gameu-accent hover:text-gameu-base'}`} data-id="element-106">
                Select Tier
              </button>
            </motion.div>)}
        </div>
      </div>
    </section>;
}